import React from "react";
import {PivotDataConfiguration} from "./configuration/pivot-data-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const PivotDataStepPanelTabs = {
    configuration: PivotDataConfiguration,
    preview: PreviewTab,
};
